import TableLoading from "./Loader/TableLoading";

export default function InfiniteScrollFooter({
  sentinelRef,
  loading,
  error,
  onRetry,
  hasNext = true,
  compact = false,
  loadingText = "",
}) {
  if (!hasNext && !error && !loading) return null;

  return (
    <div
      ref={sentinelRef}
      role="status"
      aria-live="polite"
      className={`col-span-full w-full min-h-1 flex justify-center items-center gap-2 ${compact ? "py-1" : "py-2"}`}
    >
      {loading && (
        <>
          {loadingText && (
            <span className="text-xs text-zi-text-light/60 dark:text-zi-text-dark/60">
              {loadingText}
            </span>
          )}
          <TableLoading className="text-[#808080]" />
        </>
      )}
      {error && (
        <button
          type="button"
          onClick={onRetry}
          disabled={loading}
          aria-label="تلاش دوباره برای بارگذاری"
          className="text-sm text-cyan-500 disabled:cursor-wait disabled:opacity-60"
        >
          تلاش دوباره
        </button>
      )}
    </div>
  );
}
